import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ResultDownloadModule } from './result-download/result-download.module';
import { ResultMapModule } from './result-map/result-map.module';
import { ResultPopupComponent } from './result-popup/result-popup.component';
import { SharedModule } from '../shared/shared.module';
import { ResultTreeComponent } from './result-tree/result-tree.component';

@NgModule({
  imports: [
    CommonModule,
    ResultMapModule,
    ResultDownloadModule,
    SharedModule
  ],
  declarations: [ResultPopupComponent, ResultTreeComponent]
})
export class ResultModule { }
